import { useEffect, useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/sidebar/Sidebar';
import Widget from '../../components/widget/Widget';
import Featured from '../../components/featured/Featured';
import './home.scss';
import Chart from '../../components/chart/Chart';
import List from '../../components/table/Table';

const Home = () => {
  const [salesData, setSalesData] = useState({
    todaySales: 0,
    yesterdaySales: 0,
    weekSales: 0,
    monthSales: 0,
    growthPercent: 0,
  });

  const apiUrl = process.env.REACT_APP_API_URL;

  const getMerchantIdFromToken = () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;

    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      return JSON.parse(jsonPayload).merchantId;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        const merchantId = getMerchantIdFromToken();
        if (!merchantId) return;

        const response = await fetch(
          `${apiUrl}/orders/income?merchantId=${merchantId}`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch income data');
        }

        const data = await response.json();

        setSalesData({
          todaySales: Number(data.todaySales || 0),
          yesterdaySales: Number(data.yesterdaySales || 0),
          weekSales: Number(data.weekSales || 0),
          monthSales: Number(data.monthSales || 0),
          growthPercent: Number(data.growthPercent || 0),
        });
      } catch (error) {
        console.error('Error fetching sales data:', error);
      }
    };

    fetchSalesData();
  }, [apiUrl]);

  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />

        <div className="widgets">
          <Widget type="merchant" />
          <Widget type="shop" />
          <Widget type="order" />
          <Widget type="revenue" salesData={salesData} />
        </div>

        <div className="charts">
          <Featured salesData={salesData} />
          <Chart aspect={3 / 1} title="Revenue (Last 12 Months)" />
        </div>

        <div className="listContainer">
          <div className="listTitle">Latest Transaction</div>
          <List />
        </div>
      </div>
    </div>
  );
};

export default Home;